import React from "react";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import ProductCatalogDetails from "../components/ProductCatalogDetails.js";
import "../styles/ProductSubmission.css";

function ProductCatalogDetailsPage() {
  return (
    <div className="productSubmission-screen productCatalogDetails-page-screen">
      <div className="productSubmission-header-container">
        <BusinessHubHeader />
      </div>
      <div className="productSubmission-page-content-container productCatalogDetails-page-content-container">
        <div className="business-hubb-navigator-sidebar productCatalogDetails-page-sidebar">
          <BusinessHubNavigation mode="prod" active="D" />
        </div>
        <div className="productSubmission-content-container productCatalogDetails-page-content">
          <div className="productSubmission-content-card productCatalogDetails-page-card">
            <ProductCatalogDetails />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCatalogDetailsPage;
